import { FC, ReactElement, useMemo, useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useParams } from "react-router-dom";
import { useAnalysisNavigation } from "../../../../../../hooks";
import { enums } from "../../../../../../shim/jsbridge";
import { Analysis, AnalysisCounts } from "../../../../@types";
import { useGetAnalysisCount } from "../hooks";

const {
  dynamic_analysis_routes: { NETWORK_ANALYSIS }
} = enums || {};

type Props = {
  analysis: Analysis;
  items: Array<{ key: string; component: ReactElement }>;
  titles: Array<{ key: string; title: string }>;
};

export const DYNAMIC_ANALYSIS_TABS_ID = "dynamic-analysis-tabs";

const AnalysisTabs: FC<Props> = ({ analysis, items, titles }) => {
  const { hash = "", section } = useParams();

  const { key: firstTabKey } = items.at(0) ?? {};

  const defaultSection = useMemo(
    () => section || firstTabKey || NETWORK_ANALYSIS,
    [section, firstTabKey]
  );

  const [active, setActive] = useState(defaultSection);
  const { data } = useGetAnalysisCount(hash, analysis);
  const { generateEndpointForSection } = useAnalysisNavigation({
    analysis,
    active,
    setActive,
    defaultSection: NETWORK_ANALYSIS
  });

  const handleSelectActive = (newTab: string) => {
    setActive(newTab);
  };

  return (
    <Tab.Container activeKey={active} onSelect={handleSelectActive}>
      <Nav
        id={DYNAMIC_ANALYSIS_TABS_ID}
        variant="tabs"
        className="nav-tabs--bordered"
      >
        {titles.map(({ key, title }) => (
          <LinkContainer key={key} to={generateEndpointForSection(key)}>
            <Nav.Item>
              <Nav.Link eventKey={key}>
                {title} ({(data && data[key as keyof AnalysisCounts]) ?? 0})
              </Nav.Link>
            </Nav.Item>
          </LinkContainer>
        ))}
      </Nav>
      <Tab.Content>
        {items.map(({ key, component }) => (
          <Tab.Pane key={key} eventKey={key} mountOnEnter unmountOnExit>
            {component}
          </Tab.Pane>
        ))}
      </Tab.Content>
    </Tab.Container>
  );
};

export default AnalysisTabs;
